import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6fb53c0b&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb53c0b')) {
      api.createRecord('6fb53c0b', component.options)
    } else {
      api.reload('6fb53c0b', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6fb53c0b&", function () {
      api.rerender('6fb53c0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gC2z502njizR/JS/pricehelp.vue"
export default component.exports